<template>
  <div class="block-wrap">
    <!-- <BlockTitle title-type="activity" @onSwitchTab="onSwitchTab">
      <div @click="toList">更多活动》</div>
    </BlockTitle> -->
    <div class="header-wrap">
      <div
        v-for="(bar, index) in slideBar"
        :key="index"
        class="block-item"
        @click="onSwitchTab(index)"
        :class="activeTab === index ? 'active' : ''" 
      >
        <div class="item-text">{{bar.name}}</div>
        <div class="item-bar"></div>
      </div>
      <div class="block-more">
        <div @click="toList">更多活动》</div>
      </div>
    </div>
    <div class="content-wrap">
      <div class="timeline-wrap" :class="timelineClass">
        <div class="timeline"
              :class="!tab.list.length ? 'timeline-empty' : ''"
              v-for="(tab, index) in tabs"
              :key="tab.name">
          <template v-if="tab.list.length">
            <div class="timeline-item-box" :style="timelineStyle[index]">
              <div class="timeline-item" v-for="(item, idx) in tab.list" :key="index-idx">
                <div class="item-bg"></div>
                <div class="item-line" :class="idx === timelineActive[index] ? 'active' : ''"></div>
                <template v-if="item">
                  <div class="item-time">{{item._date}}</div>
                  <div class="item-card hand" @click="toDetail(tab, item)">
                    <img class="card-img" :src="item.coverImg || hd1" alt="" />
                    <div class="card-info">
                      <h4 class="card-title">{{item.title}}</h4>
                      <div class="card-detail"><i class="detail-icon time-icon"></i><span class="detail-desc">{{item._rangeTime}}</span></div>
                      <div class="card-detail"><i class="detail-icon local-icon"></i><span class="detail-desc">地址：{{item.actAddress || '-'}}</span></div>
                      <div class="card-detail"><i class="detail-icon people-icon"></i><span class="detail-desc">已报名：<i>{{item.signUpCnt || 0}}</i>/{{item.signUpLimit || 0}}（人）</span></div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="pagi">
              <div class="button-prev" :class="timelineActive[index] === 0 ? 'disable' : ''" @click="onTimelinePrev"></div>
              <div class="button-next" :class="timelineActive[index] === tab.list.length - 1 ? 'disable' : ''" @click="onTimelineNext"></div>
            </div>
          </template>
          <Empty v-else />
        </div>
      </div>
    </div>
    <!-- <SplitLine /> -->
  </div>
</template>

<script>
import router from '@/router';
import BlockTitle from "@/components/BlockTitle";
import hd1 from '../../assets/tempImages/hd1.jpg';

export default {
  data() {
    return {
      activeTab: 0,
      slideBar: [
        {
          name: "培训",
        },
        {
          name: "会议",
        },
        {
          name: "沙龙",
        },
      ],
      timelineClass: '',
      timelineActive: [0, 0, 0],
      timelineStyle: {
        0: '',
        1: '',
        2: ''
      }
    };
  },
  props: {
    activityData: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    tabs() {
      const listConfig = ['activity', 'meeting', 'salon'];
      return listConfig.map(key => {
        this.activityData[key] = this.activityData[key] || [];
        return {
          name: key,
          list: (
            this.activityData[key].length < 5
            ? this.activityData[key].concat(new Array(5 - this.activityData[key].length).fill(null))
            : this.activityData[key]
            ).map(item => {
            item && (item.imgSrc = hd1);
            return item;
          })
        }
      })
    }
  },
  components: {
    BlockTitle,
  },
  mounted() {
    
  },
  methods: {
    toList() {
      router.push('/activity');
    },
    toDetail(tab, item) {
      router.push(`activity/${tab.name}/detail?aId=${item.id}`);
    },
    onSwitchTab(idx) {
      this.activeTab = idx;
      this.timelineClass = `timeline-wrap-${idx}`;
    },
    onTimelinePrev() {
      const idx = this.timelineActive[this.activeTab];
      if (idx === 0) return;
      this.$set(this.timelineActive, this.activeTab, idx - 1);
      this.onTimelineChange();
    },
    onTimelineNext() {
      const idx = this.timelineActive[this.activeTab];
      if (idx === this.tabs[this.activeTab]['list'].length - 1) return;
      this.$set(this.timelineActive, this.activeTab, idx + 1);
      this.onTimelineChange();
    },
    onTimelineChange() {
      const idx = this.timelineActive[this.activeTab];
      const listLenth = this.tabs[this.activeTab]['list'].length;
      if (listLenth <= 5) return;
      if (idx <= 2) {
        this.timelineStyle[this.activeTab] = 'left: 0';
      } else if (idx > 2 && idx <= listLenth - 3) {
        this.timelineStyle[this.activeTab] = `left: -${(idx - 2) * 244}px`;
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../assets/less/global.less';

.header-wrap {
  display: flex;
  align-items: center;
  height: 70px;
  justify-content: center;
  position: relative;

  .block-item {
    width: 120px;
    text-align: center;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #131415;
    line-height: 20px;
    cursor: pointer;

    .item-text {
      margin-bottom: 4px;
    }

    .item-bar {
      width: 100%;
      height: 6px;
      background: #f1f3f3;
    }

    &:hover,
    &.active {
      color: #06ae63;

      .item-bar {
        background: #06ae63;
      }
    }
  }

  .block-more {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #9d9e9e;
    cursor: pointer;
  }
}
.content-wrap {
  width: 100%;
  height: 577px;
  position: relative;
  margin-bottom: 57px;
  overflow: hidden;

  .timeline-wrap {
    width: 300%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    display: flex;

    &.timeline-wrap-1 {
      left: -100%;
    }

    &.timeline-wrap-2 {
      left: -200%;
    }

    .timeline {
      width: 33.333333%;
      height: 100%;
      overflow: hidden;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;

      &-empty {
        justify-content: center;
      }
      
      .timeline-item-box {
        height: 422px;
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        transition: left .8s ease-in-out;
      }

      .timeline-item {
        width: 244px;
        height: 100%;
        position: relative;
        display: flex;
        align-items: center;
        flex: 1 1 auto;

        .item-bg {
          position: absolute;
          width: 100%;
          left: 50%;
          top: 50%;
        } 

        .item-line {
          width: 100%;
          height: 10px;
          background: #F1F3F3;
          position: relative;

          &.active {
            &::after {
              background-image: url(../../assets/images/time-circle-active.png);
            }
          }
          
          &::after {
            content: '';
            position: absolute;
            width: 22px;
            height: 22px;
            left: 50%;
            top: -6px;
            transform: translateX(-50%);
            background: url(../../assets/images/time-circle.png) no-repeat center center;
            background-size: 100% 100%;
          }
        }
        
        .item-time {
          position: absolute;
          width: 100%;
          left: 0;
          top: 50%;
          text-align: center;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #131415;
        } 

        .item-card {
          position: absolute;
          width: 190px;
          left: 26px;
          top: 50%;

          .card-img {
            display: block;
            width: 100%;
            height: 100px;
          }

          .card-info {
            width: 100%;
            height: 110px;
            background: #FFFFFF;
            border: 1px solid #EBEBEB;
            border-top: none;
            padding: 11px 10px 0;

            .card-title {
              &:extend(.line1);
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: #131415;
              line-height: 20px;
              margin-bottom: 5px;
            }

            .card-detail {
              margin-bottom: 5px;
              height: 17px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #9D9E9E;
              line-height: 17px;
              display: flex;
              align-items: center;

              .detail-icon {
                width: 12px;
                height: 12px;
                margin-right: 5px;
                background-repeat: no-repeat;
                background-size: 100% 100%;
              }

              .time-icon {
                background-image: url(../../assets/images/icon-time.png);
              }

              .local-icon {
                background-image: url(../../assets/images/icon-local.png);
              }

              .people-icon {
                background-image: url(../../assets/images/icon-member.png);
              }

              .detail-desc {
                &:extend(.line1);

                > i {
                  color: #06AE63;
                  font-style: normal;
                }
              }
            }
          }
        }

        &:nth-child(odd) {
          .item-bg {
            transform: translate(-50%, -85px);
          }

          .item-time {
            transform: translateY(15px);
          }

          .item-card {
            transform: translateY(40px);
          }
        }

        &:nth-child(even) {
          .item-bg {
            transform: translate(-50%, 24px);
          }

          .item-time {
            transform: translateY(-41px);
          }

          .item-card {
            transform: translateY(-260px);
          }
        }

        &:nth-child(n) {
          .item-bg {
            width: 192px;
            height: 43px;
            background: url(../../assets/images/active-bg-1.png) no-repeat center center;
	          background-size: 100% 100%;
          }
        }

        &:nth-child(2n) {
          .item-bg {
            width: 146px;
            height: 59px;
            background: url(../../assets/images/active-bg-2.png) no-repeat center center;
	          background-size: 100% 100%;
          }
        }

        &:nth-child(3n) {
          .item-bg {
            width: 48px;
            height: 60px;
            background: url(../../assets/images/active-bg-3.png) no-repeat center center;
	          background-size: 100% 100%;
          }
        }

        &:nth-child(4n) {
          .item-bg {
            width: 188px;
            height: 74px;
            background: url(../../assets/images/active-bg-4.png) no-repeat center center;
	          background-size: 100% 100%;
          }
        }

        &:nth-child(5n) {
          .item-bg {
            width: 144px;
            height: 27px;
            background: url(../../assets/images/active-bg-5.png) no-repeat center center;
	          background-size: 100% 100%;
          }
        }
      }

      .pagi {
        width: 100%;
        height: 30px;
        display: flex;
        justify-content: flex-end;

        > div {
          width: 30px;
          height: 100%;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          cursor: pointer;

          &.button-prev {
            background-image: url(../../assets/images/active-prev.png);
            margin-right: 20px;

            &.disable {
              background-image: url(../../assets/images/active-prev-disable.png);
            }
          }

          &.button-next {
            background-image: url(../../assets/images/active-next.png);
            margin-right: 20px;

            &.disable {
              background-image: url(../../assets/images/active-next-disable.png);
            }
          }
        }
      }
    }
  }
}
</style>